import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./config/configureStore";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { AuthProvider } from "utils/AuthContext";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import { ErrorBoundary } from "react-error-boundary";

const store = configureStore();

const ErrorFallback = ({ error }) => (
  <div role="alert">
    <h2>Something went wrong:</h2>
    <pre>{error.message}</pre>
  </div>
);

function logErrorToService(error, info) {
  // Use your preferred error logging service
  console.error("Caught an error:", error, info);
}

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={3}
      action={(snackbarId) => (
        <IconButton onClick={() => closeSnackbar(snackbarId)}>
          <CloseIcon></CloseIcon>
        </IconButton>
      )}
    >
      <AuthProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={logErrorToService}
        >
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
